<h2 mat-dialog-title class="modal">{{title}}</h2>

<!-- Aqui está todo o conteúdo informativo do modal -->
<mat-dialog-content class="mat-typography">
    <div class="main-message">
        <p>{{text}}</p>
    </div>
    <div class="details-box" *ngIf="(extraText != null)">
        <p *ngFor="let item of extraText">
            <span *ngIf="!item">&nbsp;</span>
            {{item}}
        </p>
    </div>
</mat-dialog-content>

<!-- Opções de resposta no modal -->
<mat-dialog-actions class="buttons-dialog">
    <div class="button-container -flexEnd -mTop">
        <button mat-dialog-close class="o-button -white">{{buttonNoText}}</button>
        <button class="o-button -blue" (click)=acceptChange()>{{buttonYesText}}</button>
    </div>
</mat-dialog-actions>